export default __webpack_public_path__ + "static/media/googleDrive.30876931.svg";